// extracted by mini-css-extract-plugin
export var currencyInput = "_nb-1";
export var currencySymbol = "_nb-0";